import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import ContentManager from '../../components/admin/ContentManager';

export default function VarietiesPage() {
  return (
    <AdminLayout>
      <ContentManager
        title="Varieties Management"
        subtitle="Manage fruit varieties for commercialization"
        contentType="varieties"
        fields={[
          // Basic Information
          { name: 'name', label: 'Variety Name', type: 'text', required: true },
          { name: 'fruit_type', label: 'Fruit Type', type: 'select', options: ['Mango', 'Guava', 'Bael', 'Jamun', 'Banana', 'Aonla', 'Other'] },
          { name: 'summary', label: 'Short Summary', type: 'textarea', placeholder: 'Brief description for cards' },
          { name: 'description', label: 'Detailed Description', type: 'richtext', hint: 'Full variety details with formatting' },
          
          // Images - File Upload
          { name: 'image_file', label: 'Variety Image', type: 'file', fileType: 'image', hint: 'Upload variety image (JPG, PNG, WEBP)' },
          { name: 'image_url', label: 'Or Image URL (if not uploading)', type: 'text', placeholder: 'https://example.com/image.jpg' },
          
          // Developer Information
          { name: 'inventors', label: 'Inventor(s)/Developer(s)', type: 'text', placeholder: 'e.g., Dr. A.K. Singh, Dr. B.K. Sharma' },
          { name: 'collaborators', label: 'Collaborator(s)', type: 'text' },
          { name: 'maintainer_inventor', label: 'Maintainer Inventor', type: 'text' },
          
          // Year Information
          { name: 'year_of_development', label: 'Year of Development', type: 'text', placeholder: 'e.g., 2015' },
          { name: 'year_of_commercialization', label: 'Year of Commercialization', type: 'text' },
          { name: 'year_of_release', label: 'Year of Release', type: 'text' },
          
          // Registration
          { name: 'ppvfra_registration', label: "PPVFRA Breeder's Right Registration", type: 'text' },
          { name: 'ic_number', label: 'IC Number', type: 'text' },
          
          // Licensing Information
          { name: 'nature_of_license', label: 'Nature of License', type: 'select', options: ['Non-Exclusive', 'Exclusive', 'Open'] },
          { name: 'duration', label: 'Duration', type: 'text' },
          { name: 'licensing_territory', label: 'Licensing Territory', type: 'text', defaultValue: 'India' },
          { name: 'license_fee', label: 'License Fee', type: 'text' },
          { name: 'target_customers', label: 'Target Customers', type: 'text' },
          { name: 'royalty', label: 'Royalty', type: 'text' },
          
          // Category Flags
          { name: 'is_nutraceutical', label: 'Nutraceutical Rich Variety', type: 'checkbox', defaultValue: false, checkboxLabel: 'Mark as nutraceutical rich variety' },
          { name: 'is_climate_resilient', label: 'Climate Resilient Variety', type: 'checkbox', defaultValue: false, checkboxLabel: 'Mark as climate resilient' },
          { name: 'is_highlighted', label: 'Highlighted (Homepage)', type: 'checkbox', defaultValue: true, checkboxLabel: 'Show in homepage carousel' },
          
          // Display Settings
          { name: 'priority', label: 'Priority', type: 'number', defaultValue: 0, min: 0, max: 100, hint: 'Higher priority = shown first on homepage. 0 = normal listing' },
          { name: 'is_active', label: 'Active', type: 'checkbox', defaultValue: true, checkboxLabel: 'Item is active' },
          { name: 'is_published', label: 'Published', type: 'checkbox', defaultValue: true, checkboxLabel: 'Visible to public' },
        ]}
        columns={['name', 'fruit_type', 'is_highlighted', 'priority', 'is_published']}
      />
    </AdminLayout>
  );
}
